/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListJobScorecardDefinitionsParams = {
/**
 * When resolved_from is job, include all job rows (including archived). Otherwise return the resolved rows followed by the job's archived rows.
 */
include_archived?: boolean;
};
